import apiValidation from '../validation/ApiRespValidation'

const productsMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos");
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            id: item.id ?? '',
            sku: item.sku ?? '',
            nombre: item.nombre ?? '',
            descripcion: item.descripcion ?? '',
            precio: item.precio ?? '',
            creation_date: item.creation_date ?? '',
            modification_date: item.modification_date ?? '',
            Estado: item.nombre_parametro ?? '',
        }));

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            url: dataResponse.url
        };
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        };
    }
};

const bodegasMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos");
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            id: item.id ?? '',
            Nombre: item.nombre ?? '',
            Ubicacion: item.ubicacion ?? '',
            Codigo: item.codigo ?? '',
            TipoId: item.id_tipo ?? '',
            estadoNemo: item.estado ?? '',
            Tipo: item.tipo_nombre ?? '',
            Estado: item.nombre_parametro ?? ''
        }));

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            url: dataResponse.url
        };
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        };
    }
};

const productsDetailsMapper = (data) => {

    let responseMapper = [];
    let responseTableMapper = [];
    try {
        for (var i = 0; i < data.length; i++) {
            responseMapper[i] = {
                id: data[i].id ?? '',
                sku: data[i].sku ?? '',
                nombre: data[i].nombre ?? '',
                descripcion: data[i].descripcion ?? '',
                precio: data[i].precio ?? '',
                creation_date: data[i].creation_date ?? '',
                modification_date: data[i].modification_date ?? '',
                Estado: data[i].nombre_parametro ?? '',
            }
            responseMapper.push();

            responseTableMapper[i] = {
                id: data[i].id ?? '',
                sku: data[i].sku ?? '',
                nombre: data[i].nombre ?? '',
                descripcion: data[i].descripcion ?? '',
                precio: data[i].precio ?? '',
                nemonico_cat: data[i].nemonico_cat ?? '',
                nemonico_tipro: data[i].nemonico_tipro ?? '',
                nemonico_marca: data[i].nemonico_marca ?? '',
                nemonico_modelo: data[i].nemonico_modelo ?? '',
                nemonico_materiales: data[i].nemonico_materiales ?? '',
                nemonico_estados_prod: data[i].nemonico_estados_prod ?? '',
                nemonico_depar: data[i].nemonico_depar ?? '',
                stock: data[i].stock ?? '',
                nombre_parametro: data[i].nombre_parametro ?? '',
                grava_iva: data[i].grava_iva ?? '',
                tarifa_descuento: data[i].tarifa_descuento ?? '',
                id_bodega: data[i].id_bodega ?? '',
                creation_date: data[i].creation_date ?? '',
                modification_date: data[i].modification_date ?? '',
                peso: data[i].peso ?? '',
                alto: data[i].alto ?? '',
                ancho: data[i].ancho ?? '',
                largo: data[i].largo ?? '',
                talla: data[i].talla ?? '',
                dimensiones: data[i].dimensiones ?? '',
                fecha_lanzamiento: data[i].fecha_lanzamiento ?? '',
                fecha_vencimiento: data[i].fecha_vencimiento ?? '',
                garantia: data[i].garantia ?? '',
                cantidad_minima_pedido: data[i].cantidad_minima_pedido ?? '',
                fabricante: data[i].fabricante ?? '',
                anio_fabricacion: data[i].anio_fabricacion ?? '',
                observacion: data[i].observacion ?? ''
            }
            responseTableMapper.push();
        }
    } catch (error) {
        return apiValidation.apiError500();
    }

    const response = {
        "error": false,
        "variant": "success",
        "responseTableMapper": responseTableMapper[0],
    }

    return response;
}

const mediaMapper = (data) => {

    let responseMapper = [];
    let responseTableMapper = [];
    try {
        for (var i = 0; i < data.length; i++) {
            responseMapper[i] = {
                id: data[i].id ?? '',
                url: global.IMG2 + data[i].url ?? '',
                description: data[i].description ?? '',
                type: data[i].type ?? ''
            }
            responseMapper.push();

            responseTableMapper[i] = {
                id: data[i].id ?? '',
                url: global.IMG2 + data[i].url ?? '',
                description: data[i].description ?? '',
                type: data[i].type ?? ''
            }
            responseTableMapper.push();
        }
    } catch (error) {
        return apiValidation.apiError500();
    }

    const response = {
        "error": false,
        "variant": "success",
        "responseTableMapper": responseTableMapper,
    }

    return response;
}

const maintenanceAccesUsersMapper = (data) => {
    let moduleMapper = [];
    for (var i = 0; i < data.length; i++) {
        moduleMapper[i] = {
            moduleName: data[i].moduleName ?? '',
            id: data[i].id ?? '',
            masterId: data[i].nemonico_menu ?? '',
            name: data[i].name ?? '',
            icon: data[i].icon ?? '',
            path: data[i].path ?? '',
            order: data[i].order ?? '',
            status: data[i].status ?? '',
        }
        moduleMapper.push();
    }
    return moduleMapper;
}

const maintenanceUsersMapper = (data) => {
    let moduleMapper = [];
    let moduleUsersMapper = [];
    for (var i = 0; i < data.length; i++) {
        moduleMapper[i] = {
            id: data[i].id ?? '',
            identification: data[i].identification ?? '',
            names: data[i].names ?? '',
            middleNames: data[i].middle_names ?? '',
            direction: data[i].direction ?? '',
            phone: data[i].phone ?? '',
            cellphone: data[i].cellphone ?? '',
            sex: data[i].sex ?? '',
            userName: data[i].user_name ?? '',
            email: data[i].email ?? '',
            status: data[i].status ?? '',
            lastLogin: data[i].last_login ?? '',
        }
        moduleMapper.push();

        moduleUsersMapper[i] = {
            id: data[i].id ?? '',
            Identificación: data[i].identification ?? '',
            Nombres: data[i].names ?? '',
            Apellidos: data[i].middle_names ?? '',
            Dirección: data[i].direction ?? '',
            Celular: data[i].cellphone ?? '',
            Correo: data[i].email ?? '',
        }
        moduleUsersMapper.push();
    }

    const response = {
        "error": false,
        "variant": "success",
        "moduleMapper": moduleMapper,
        "moduleUsersMapper": moduleUsersMapper,
    }

    return response;
}

const businessMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            id: data[i].id ?? '',
            identification: data[i].identification ?? '',
            establishment: data[i].establishment ?? '',
            name: data[i].name ?? '',
            cellphone: data[i].cellphone ?? '',
            comercialName: data[i].comercial_name ?? '',
            direction: data[i].direction ?? '',
            phone: data[i].phone ?? '',
            email: data[i].email ?? '',
            vision: data[i].vision ?? '',
            mision: data[i].mision ?? '',
            objetive: data[i].objetive ?? '',
            path_img: data[i].path_img ?? '',
        }
        responseMapper.push();
    }
    return responseMapper;
}

const typeMapper2 = (data) => {
    let responseMapper = [];
    for (var f = 0; f < data.length; f++) {
        responseMapper[f] = {
            id: data[f].id ?? '',
            Descripción: data[f].descripcion ?? '',
            //description: data[f].description ?? '',
            Porcentaje: data[f].value_data ?? ''
        }
        responseMapper.push();
    }
    return responseMapper;
}

const typeMapper = (data) => {
    let responseMapper = [];
    let contParameter = 0;
    for (var i = 0; i < data.length; i++) {
        if (data[i]["master_id"] === "0" && data[i]["name"] === "Forma de Pago") {
            for (var f = 0; f < data.length; f++) {
                if (data[f]["master_id"] !== "0") {
                    if (data[i]["id"] === data[f]["master_id"]) {
                        responseMapper[contParameter] = {
                            id: data[f].id ?? '',
                            //masterId: data[f].master_id ?? '',
                            //businessId: data[f].business_id ?? '',
                            Nombre: data[f].name ?? '',
                            Descripción: data[f].description ?? '',
                            "Valor (%)": data[f].value_data + "%" ?? '',
                            Estado: data[f].status === "1" ? 'Activo' : "Inactivo"
                        }
                        responseMapper.push();
                        contParameter++;
                    }
                }
            }
        }
    }
    return responseMapper;
}

const ivaMapper = (data) => {
    let responseMapper = [];
    let contParameter = 0;
    for (var i = 0; i < data.length; i++) {
        if (data[i]["master_id"] === "0" && data[i]["name"] === "IMPUESTOS") {
            for (var f = 0; f < data.length; f++) {
                if (data[f]["master_id"] !== "0") {
                    if (data[i]["id"] === data[f]["master_id"]) {
                        responseMapper[contParameter] = {
                            id: data[f].id ?? '',
                            "valueData": data[f].value_data ?? ''
                        }
                        responseMapper.push();
                        contParameter++;
                    }
                }
            }
        }
    }
    return responseMapper;
}

const getYearsMapper = () => {
    let responseMapper = [];
    for (var i = 2024; i <= (2024 + 5); i++) {
        responseMapper[i] = {
            id: i,
            description: i
        }
        responseMapper.push();
    }
    return responseMapper;
}

const parameterMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            id: data[i].id ?? '',
            name: data[i].descripcion ?? '',
            description: data[i].descripcion ?? '',
            valueData: data[i].value_data ?? '',
            status: data[i].status === '1' ? 'Activo' : 'Inactivo'
        }
        responseMapper.push();
    }

    return responseMapper;
}

const accessDataMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            id: data[i].id ?? '',
            nombremodule: data[i].nombremodule ?? '',
            masterId: data[i].master_id ?? '',
            name: data[i].name ?? '',
        }
        responseMapper.push();
    }

    return responseMapper;
}

const accessUserMenuMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            menuId: data[i].menu_id ?? ''
        }
        responseMapper.push();
    }

    return responseMapper;
}

const templatesMapper = (data) => {
    let responseMapperTable = [];
    for (var i = 0; i < data.length; i++) {
        responseMapperTable[i] = {
            id: data[i].id ?? '',
            Nombre: data[i].name ?? '',
            Descripción: data[i].description ?? '',
            "Fecha Creación": data[i].creation_date ?? '',
            "Fecha Modificación": data[i].modification_date ?? '',
            Estado: data[i].status === '1' ? 'Activo' : 'Inactivo'
        }
        responseMapperTable.push();
    }

    let responseMapper = [];
    for (var f = 0; f < data.length; f++) {
        responseMapper[f] = {
            id: data[f].id ?? '',
            name: data[f].name ?? '',
            description: data[f].description ?? '',
            jsonHtml: data[f].jsonHtml ?? '',
            html: data[f].html ?? '',
        }
        responseMapper.push();
    }

    const response = {
        "error": false,
        "variant": "success",
        "responseMapperTable": responseMapperTable,
        "responseMapper": responseMapper,
    }


    return response;
}


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    productsMapper,
    bodegasMapper,
    maintenanceUsersMapper,
    maintenanceAccesUsersMapper,
    businessMapper,
    getYearsMapper,
    typeMapper,
    parameterMapper,
    ivaMapper,
    templatesMapper,
    accessDataMapper,
    accessUserMenuMapper,
    productsDetailsMapper,
    mediaMapper,
    typeMapper2
}